<app-page>
    <app-title>{{ 'stripe_account_locations' | translate }}</app-title>
    <app-locations [locationsModel]="locationsModel"></app-locations>
</app-page>
